



































































































import Modal from "../../core/Modals/Modal.vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Employe } from "../../models/Employe";
import { DateUtils } from "../../utils/DateUtils";
import moment from "moment";
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";
import ExportButton from "../../core/UI/ExportButton.vue";

export default {
    name: "DisponibilitesEmployesModal",
    components: { CheckboxInput, ExportButton, Modal },
    props: {
        showModal: Boolean,
        startDate: String,
        endDate: String,
    },
    data() {
        return {
            employesDisponibilites: [],
            days: [],
            hideEmployesNonDisponibles: true,
            InterventionApi: new InterventionApi(),
        };
    },
    methods: {
        createDaysList(): void {
            this.days = [];

            let startDate = moment(this.startDate, "YYYY-MM-DD");
            let endDate = moment(this.endDate, "YYYY-MM-DD").add(1, "day");
            while (startDate.isBefore(endDate)) {
                this.days.push(startDate.format("YYYY-MM-DD"));
                startDate.add(1, "days");
            }
        },
        getDisponibilites(): void {
            let self = this;
            self.employesDisponibilites = [];
            self.InterventionApi.getEmployesDisponibilites(
                self.startDate,
                self.endDate
            ).then(function (response) {
                self.employesDisponibilites = response;
                _.map(
                    self.employesDisponibilites,
                    function (employeDisponibilite) {
                        employeDisponibilite.employe = new Employe(
                            employeDisponibilite.employe
                        );
                    }
                );
            });
        },
        closeModal(): void {
            this.$emit("close-modal");
        },
        getExportParams(): Object {
            return {
                start_date: this.startDate,
                end_date: this.endDate,
            };
        },
        // UI
        filteredEmployesDisponibilites() {
            let self = this;
            return _.filter(
                this.employesDisponibilites,
                function (employeDisponibilite) {
                    if (self.hideEmployesNonDisponibles) {
                        let hasDisponibilites = false;
                        _.each(
                            employeDisponibilite.disponibilites,
                            function (disponibilite) {
                                if (disponibilite.total > 0) {
                                    hasDisponibilites = true;
                                    return hasDisponibilites;
                                }
                            }
                        );
                        return hasDisponibilites;
                    }
                    return true;
                }
            );
        },
        dateToStr(date, format: string = "DD/MM/YYYY"): string {
            return DateUtils.sqlToDateStr(date, format);
        },
        displayDisponibilite(employeDisponibilite, day): string {
            if (employeDisponibilite.disponibilites[day]) {
                return employeDisponibilite.disponibilites[day]["total"];
            }
        },
        totalHeuresContrat(): number {
            let res = _.reduce(
                this.employesDisponibilites,
                function (sum, employeDisponibilite) {
                    return sum + employeDisponibilite.heures_contrat;
                },
                0
            );
            let nbJours = this.days.length;
            res = (res * nbJours) / 7;
            return _.round(res, 2);
        },
        totalHeuresPlanning(): number {
            let res = _.reduce(
                this.employesDisponibilites,
                function (sum, employeDisponibilite) {
                    return sum + employeDisponibilite.heures_planning;
                },
                0
            );
            return _.round(res, 2);
        },
        totalDisponibiliteEmploye(employeDisponibilite): number {
            let res = _.reduce(
                employeDisponibilite.disponibilites,
                function (sum, value) {
                    return sum + value["total"];
                },
                0
            );
            return _.round(res, 2);
        },
        totalDisponibiliteDay(day): number {
            let res = _.reduce(
                this.employesDisponibilites,
                function (sum, employeDisponibilite) {
                    if (employeDisponibilite.disponibilites[day]) {
                        return (
                            sum +
                            employeDisponibilite.disponibilites[day]["total"]
                        );
                    } else {
                        return sum;
                    }
                },
                0
            );
            return _.round(res, 2);
        },
        totalAll(): number {
            let self = this;
            let res = _.reduce(
                this.employesDisponibilites,
                function (sum, employeDisponibilite) {
                    return (
                        sum +
                        self.totalDisponibiliteEmploye(employeDisponibilite)
                    );
                },
                0
            );
            return _.round(res, 2);
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function () {
                if (this.showModal) {
                    this.getDisponibilites();
                    this.createDaysList();
                }
            },
        },
    },
};
